import { MessageSquare, Mic, MicOff, PhoneOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';

interface VoiceCallControlsProps {
  isMuted: boolean;
  onToggleMute: () => void;
  onMinimize: () => void;
  onHangUp: () => void;
  disabled?: boolean;
}

export const VoiceCallControls = ({
  isMuted,
  onToggleMute,
  onMinimize,
  onHangUp,
  disabled = false,
}: VoiceCallControlsProps) => {
  const { t } = useTranslation();
  const muteLabel = isMuted
    ? t('VOICE_CALL_UNMUTE', { defaultValue: 'Unmute microphone' })
    : t('VOICE_CALL_MUTE', { defaultValue: 'Mute microphone' });
  const showChatLabel = t('VOICE_CALL_SHOW_CHAT', { defaultValue: 'Show chat' });
  const endLabel = t('VOICE_CALL_END', { defaultValue: 'End call' });

  return (
    <TooltipProvider>
      <div className="flex items-center gap-4">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="secondary"
              size="icon"
              className="h-12 w-12 [&_svg]:size-5"
              aria-label={muteLabel}
              aria-pressed={isMuted}
              disabled={disabled}
              onClick={onToggleMute}
            >
              {isMuted ? <MicOff /> : <Mic />}
            </Button>
          </TooltipTrigger>
          <TooltipContent>{muteLabel}</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="destructive"
              size="icon"
              className="h-14 w-14 [&_svg]:size-6"
              aria-label={endLabel}
              disabled={disabled}
              onClick={onHangUp}
            >
              <PhoneOff />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{endLabel}</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="secondary"
              size="icon"
              className="h-12 w-12 [&_svg]:size-5"
              aria-label={showChatLabel}
              disabled={disabled}
              onClick={onMinimize}
            >
              <MessageSquare />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{showChatLabel}</TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};
